import config from '~/config.js';
import jwtService from './jwt.service.js';

const SESSION_KEY = 'ACCOUNTS_SESSION';

export default {
  bootstrap() {
    if (config.journal && config.journal.agent) {
      var journalAgent = document.createElement('script');
      journalAgent.setAttribute('src', config.journal.agent);
      journalAgent.onload = () => {
        if ('GLJournal' in window) {
          window.GLJournal.bootstrap({ serviceId: config.serviceId, url: config.journal.url });
        }
      };
      document.head.appendChild(journalAgent);
    }
  },

  dispatchStartSession() {
    const currentCookie = jwtService.loadSessionToken();
    if (currentCookie) {
      const [signature] = currentCookie.split('.').reverse();
      const currentSession = sessionStorage.getItem(SESSION_KEY);
      if (signature !== currentSession) {
        const payload = {
          verb: 'app_started',
          object: {
            origin: { id: config.serviceId, label: 'accounts' }
          }
        };
        this.fireEvent(payload);
        sessionStorage.setItem(SESSION_KEY, signature);
      }
    }
  },

  fireEvent(payload) {
    document.dispatchEvent(new CustomEvent('journal', { detail: payload }));
  }
};
